import { text_mod_7, } from "../text/Text.js";
export const module07 = {
  title:
    "Я збираюся до школи",
  questions: [
    {
      id: 1,
      onlyText: true,
      text: text_mod_7,
    },
  ]
};